<template>
  <div class="filter-bar">
    <el-select v-model="filters.type" placeholder="题型" @change="onChange">
      <el-option v-for="(label, val) in typeOptions" :key="val" :label="label" :value="val"></el-option>
    </el-select>
    <el-select v-model="filters.difficult" placeholder="难度" @change="onChange">
      <el-option v-for="(label, val) in difficultyOptions" :key="val" :label="label" :value="val"></el-option>
    </el-select>
    <el-select v-model="filters.source" placeholder="来源" @change="onChange">
      <el-option v-for="opt in sourceOptions" :key="opt" :label="opt" :value="opt"></el-option>
    </el-select>
    <el-select v-model="filters.year" placeholder="年份" @change="onChange">
      <el-option v-for="yr of [2025,2024,2023]" :key="yr" :label="yr" :value="yr"></el-option>
    </el-select>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
const emit = defineEmits(['filter-change'])

const typeOptions = { 1: '单选题', 2: '填空题', 3: '解答题' }
const difficultyOptions = { 1: '易', 2: '中', 3: '难' }
const sourceOptions = ['midterm','final','real']

const filters = reactive({
  type: null,
  difficult: null,
  source: null,
  year: null
})

function onChange() {
  emit('filter-change', { ...filters })
}
</script>

<style scoped>
.filter-bar {
  padding: 10px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}
.el-select:not(:last-child) {
  margin-right: 12px;
}
</style>
